import { IsNotEmpty, IsString, IsArray, IsOptional } from 'class-validator';

import type { DeadlineReference } from '@vk-hr-tek/ui/FlowTree';

import { Deadline } from './deadline.dto';

export type FormDeadlineReference = DeadlineReference | '-';

export class DeadlineFormDto {
  @IsString()
  @IsNotEmpty()
  group: string;

  @IsString()
  @IsOptional()
  hasDeadline: string;

  @IsArray()
  @IsNotEmpty()
  deadline: Deadline[];
}
